import React, { Fragment } from 'react';
import * as S from './style';

import { Label, SpaceDiv } from 'components';
import * as PAGE_URL from 'router/PageUrl';

interface Props {
  children?: React.ReactNode;
  title?: Array<string>;
  subTitle?: Array<string>;
  image?: React.ReactElement;
  btn?: React.ReactElement;
  btnWidth?: number;
  inHomeBtn?: boolean;
}

function FormStatusInfo({
  children,
  title,
  subTitle,
  image,
  btn,
  btnWidth,
  inHomeBtn,
}: Props): React.ReactElement {
  return (
    <S.StatusInfoContainer>
      {title ? (
        <Fragment>
          <S.TitleWrapper>
            {title.map((item, index) => (
              <Label
                key={index}
                fontStyle={'h3_bold'}
                color={'cray_opacity_800'}
                contents={item}
              />
            ))}
          </S.TitleWrapper>
          <SpaceDiv height={64} />
        </Fragment>
      ) : null}
      {image ? (
        <Fragment>
          <S.ImgaeWrapper>{image}</S.ImgaeWrapper>
        </Fragment>
      ) : null}
      {subTitle ? (
        <S.SubTitleWrapper>
          {subTitle.map((item, index) => (
            <Label
              key={index}
              fontStyle={'title_bold'}
              color={'cray_opacity_800'}
              contents={item}
            />
          ))}
        </S.SubTitleWrapper>
      ) : null}
      {children ? <S.ChildrenWrapper>{children}</S.ChildrenWrapper> : null}
      {btn ? (
        <S.BtnWrapper btnWidth={btnWidth}>
          <SpaceDiv height={36} />
          {btn}
        </S.BtnWrapper>
      ) : null}
      {inHomeBtn ? (
        <S.BtnHomeWrapper>
          <SpaceDiv height={16} />
          <S.BtnHome
            fontStyle={'body2'}
            color={'blue_900'}
            backGroundColor={'transparent'}
            href={PAGE_URL.MAIN.path}
          >
            {'홈 화면으로 돌아가기'}
          </S.BtnHome>
        </S.BtnHomeWrapper>
      ) : null}
    </S.StatusInfoContainer>
  );
}

export default FormStatusInfo;
